import React, { Component } from 'react';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import UpdatePackages from './UpdatePackagesView';
import Constants from '../../../common/constants/Constants';
import Store from '../../../redux/Store';
import { getReadOnlyBlobSasToken } from '../../FileManagment/FileManagement.actions';
import {
  getUpdates,
  getRegions,
  getUserRegion,
  deleteUpdate,
  savePackage,
  getBlobUrlForPackageUpload,
} from './UpdatePackages.actions';
import { showSnackbar } from '../../../common/state/snackbar/Snackbar.actions';
import BlobUploadUtils from '../../../common/utils/BlobUploadUtils';

class UpdatePackagesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateList: [],
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
      isFetching: false,
      supFileInput: '',
      supFileName: '',
      uploadCompleted: 0,
      regions: [],
      userRegion: {},
    };
  }

  componentDidMount() {
    this.setState({ isFetching: true }, () => this._loadData());
  }

  _loadData = () => {
    getRegions()
      .then((res) => {
        this.setState({
          regions: res.body,
        });
        return getUpdates();
      })
      .then((res) => {
        this.setState({
          updateList: res.body,
          isFetching: false,
        });
        return getUserRegion();
      })
      .then((res) => {
        this.setState({
          userRegion: res.body.RegionId,
        });
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to load update packages.',
          })
        );
      });
  };

  render() {
    return (
      <UpdatePackages
        state={this.state}
        showConfirmDialog={this.state.showConfirmDialog}
        messageToConfirm={this.state.messageToConfirm}
        isFetching={this.state.isFetching}
        onClickDelete={this._onDeleteUpdate}
        onClickDownload={this._onClickDownload}
        onClickUpload={this._onClickUploadAsync}
        onClickSupFileBrowse={this._onSupFileBrowse}
        sortPackages={this._sortPackages}
        supVisibilityByRegionsRestriction={
          this.props.user.Settings.SupVisibilityByRegionsRestriction
        }
        userPermissions={this.props.user.Permissions}
        userRegionId={this.state.userRegion}
      />
    );
  }

  _sortPackages = (packages) => {
    packages.sort(function (a, b) {
      if (a.Name < b.Name) {
        return -1;
      }
      if (a.Name > b.Name) {
        return 1;
      }
      return 0;
    });
    return packages;
  };

  _onDeleteUpdate = (event, updateToDelete) => {
    event.stopPropagation();
    this.setState({
      messageToConfirm: `Are you sure you want to delete the update package named "${updateToDelete.Name}"?`,
      showConfirmDialog: {
        title: `Delete update ${updateToDelete.Name}`,
        show: true,
        action: () => this._onConfirmDeleteUpdate(updateToDelete),
        cancel: this._onCanceldeleteUpdate,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmDeleteUpdate = (updateToDelete) => {
    if (updateToDelete) {
      this.setState({ showConfirmDialog: { disableMainAction: true } });

      deleteUpdate(updateToDelete.PackageId)
        .then(() => {
          getUpdates().then((res) => {
            this.setState({
              updateList: res.body,
              messageToConfirm: '',
              showConfirmDialog: {
                show: false,
                disableMainAction: false,
                action: () => {},
                cancel: () => {},
              },
            });
          });
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
              message: 'Update package deleted successfully.',
            })
          );
        })
        .catch((res) => {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message: 'Failed to delete the update package. Please try again.',
            })
          );
        });
    }
  };

  _onCanceldeleteUpdate = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
      },
    });
  };

  _onClickDownload = (el) => {
    getReadOnlyBlobSasToken(el.BlobUrl)
      .then((res) => {
        let token = res.body;
        let pathWithToken = el.BlobUrl + token;
        var downloadWindow = window.open(pathWithToken);
        try {
          downloadWindow.focus();
        } catch (e) {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message:
                'Download blocked by browser. Add this site to your exception list and try again.',
            })
          );
        }
      })
      .catch((err) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to download the selected update package.',
          })
        );
      });
  };

  _onSupFileBrowse = () => {
    this.setState({ uploadCompleted: 0 });
    let fileFullPath = this.state.supFileInput.files[0].name;
    let filePathArray = fileFullPath.split('.');
    if (filePathArray[filePathArray.length - 1].toLowerCase() == 'sup') {
      this.setState({ supFileName: fileFullPath });
    } else {
      this.setState({ supFileName: 'Select a .sup file' });
    }
  };

  _setUploadProgress = (value) => {
    this.setState({ uploadCompleted: value });
  };

  _generateBlobName = (fileName) => {
    let nameArray = fileName.split('.');
    return `${nameArray[0]}_${uuidv4()}.SUP`;
  };

  _onClickUploadAsync = async () => {
    const file = this.state.supFileInput.files[0];
    const blobName = this._generateBlobName(file.name);

    let filePathArray = file.name.split('.');
    const fileExtension = filePathArray[filePathArray.length - 1].toLowerCase();

    if (this.state.supFileInput.files.length != 1 || fileExtension !== 'sup') {
      this._showErrorMessage('No .sup file selected.');
      return;
    }

    try {
      const blobUrlRes = await getBlobUrlForPackageUpload(blobName);
      const blockBlobClient = await BlobUploadUtils.createBlockBlobClient(blobUrlRes.body);
      var doesBlobExist = await blockBlobClient.exists();
      if (doesBlobExist === true) {
        this._showErrorMessage('File with the same name already exists.');
        throw new Error();
      } else {
        await BlobUploadUtils.uploadToBlobStorage(blockBlobClient, file, this._setUploadProgress);
        var verifyRes = await savePackage(blockBlobClient.url);
        this._handleApiResponse(verifyRes);
      }
    } catch (err) {
      this._handleUploadError(err);
    }
  };

  _handleApiResponse = (res) => {
    let newPackage = res.body;
    this.setState((prevState) => ({
      updateList: [...prevState.updateList, newPackage],
    }));
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: 'Update package uploaded successfully.',
      })
    );
  };

  _handleUploadError = (err) => {
    const errorMessage =
      err && err.response && err.response.body && err.response.body.Message
        ? err.response.body.Message
        : 'Failed to upload the update package.';
    this._showErrorMessage(errorMessage);
  };

  _showErrorMessage = (message) => {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: message,
      })
    );
  };
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(UpdatePackagesContainer);
